// E3.2: SheetJS lazy per CDN laden - gleicher Versions-Pin und
// data-xlsx-cdn-Dedup wie die bewussten Mini-Duplikate in
// BaustellenAuswertung.js und Material.js (alle drei Stellen teilen so
// dasselbe Script-Tag). Die zwei bestehenden Duplikate bleiben unangetastet
// (User-Entscheidung 21.07.2026: kein Refactor-Scope in E3.2) - neue
// Nutzungen importieren ab jetzt von hier.
export function loadXLSX() {
  return new Promise((resolve, reject) => {
    if (window.XLSX) return resolve(window.XLSX);
    const existing = document.querySelector('script[data-xlsx-cdn]');
    if (existing) {
      existing.addEventListener('load', () => window.XLSX ? resolve(window.XLSX) : reject(new Error('XLSX nicht verfügbar')));
      existing.addEventListener('error', () => reject(new Error('XLSX-Skript konnte nicht geladen werden')));
      return;
    }
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/xlsx@0.18.5/dist/xlsx.full.min.js';
    s.async = true;
    s.dataset.xlsxCdn = '1';
    s.onload = () => window.XLSX ? resolve(window.XLSX) : reject(new Error('XLSX nicht verfügbar'));
    s.onerror = () => reject(new Error('XLSX-Skript konnte nicht geladen werden'));
    document.head.appendChild(s);
  });
}
